export class CommissionRow {
  accountId: string;
  currency: string;
  date: number;
  source: string;
  amountInUSD: number;
  sum: number;
  // executionSum: number;

  // constructor(date: Date, accountId: string, currency: string, source: string) {
  //   this.date = date;
  //   this.accountId = accountId;
  //   this.currency = currency;
  //   this.source = source;
  // }

  constructor(accountId: string, currency: string, date: number, source: string, sum: number) {
    this.accountId = accountId;
    this.currency = currency;
    this.date = date;
    this.source = source;
    this.sum = sum;
  }

  // constructor(accountId: string, currency: string, source: string, commissionSum: number) {
  //   this.accountId = accountId;
  //   this.currency = currency;
  //   this.source = source;
  //   this.commissionSum = commissionSum;
  // }
}
